export default __webpack_public_path__ + "static/media/PERMITMODULE.c1ab6d53.png";